import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";
import { FormatData } from "utils/FormatData";

interface FileSizeSummarizeProps {
  files: API_DownloadWizardRequestFile[];
}

export const FileSizeSummarize = ({ files }: FileSizeSummarizeProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const fileSizeToStr = (filesToSum: FileSizeSummarizeProps["files"]) =>
    FormatData.formatBytes(
      filesToSum.reduce((totalSize, file) => {
        if (file.size && typeof file.size === "number") {
          totalSize += file.size;
        }
        return totalSize;
      }, 0)
    );

  if (!files.length) {
    return <span />;
  }
  return (
    <span>
      {files.length} {t("files selected")} ({fileSizeToStr(files)})
    </span>
  );
};
